<template>
  <div>
    <button-style-1 v-if="system === 'ShopShappy'" />
    <button-style-2 v-else />
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'
import ButtonStyle1 from '@/components/CartButton/ButtonStyle1'
import ButtonStyle2 from '@/components/CartButton/ButtonStyle2'

export default {
  name: 'CartButton',
  components: {
    'button-style-1': ButtonStyle1,
    'button-style-2': ButtonStyle2
  },
  computed: {
    system () {
      return Cart.getSystem()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CartButton/index.vue